import React from 'react';

const EmptyEntityInfoPanel = ({
  icon = 'arrow_back',
  header = 'No note selected',
  message = 'Select a note to view its details here.',
  actionLabel = null,
  onAction = null,
}) => {
  return (
    <div className="empty-entity-panel">
      <div className="empty-entity-panel__graphic">
        <span className="material-icons empty-entity-panel__icon">{icon}</span>
      </div>
      <h2 className="empty-entity-panel__title">{header}</h2>
      {message && <p className="empty-entity-panel__body">{message}</p>}
      {actionLabel && onAction && (
        <button className="empty-entity-panel__btn" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyEntityInfoPanel;
